import service from '../service.js';

export default {
    register(data, uuid) {
        return service.post('/event/run/register', {
            uuid: uuid,
            registrant: data,
        });
    },
    getSchedule() {
        return service.get('/event/run'); 
    },
    getSegment(){
        return service.get('/event/run/segment');
    },
    sendEmail(data) {
        return service.post('/event/run/email', {
            email: data,
        });
    },
    getRegistrants(uuid) {
        return service.get('/event/run/registrants', {
            uuid: uuid,
        });
    },
    hasRegistered(uuid) {
        return service.get('/event/run/registered', {
            uuid: uuid,
        });
    },
}